import cloneDeep from 'lodash.clonedeep';
import { act } from 'react-dom/test-utils';
import types from './actionTypes';
import { llmData } from './actions';


const initialState = {
  details: {
    name: "",
    description: "",
    _id: null
  },
  logHelpers: {},
  openValidator: false,
  openDeployment: false,
  logRedirectionData: null,
  snackbar: {
    open: false,
    autoHideDuration: 6000,
    severity: 'success',
    message: '',
    anchorOrigin: { vertical: "top", horizontal: "right" },
    save: false
  },
  topRightInfo: {
    open: false,
    message: '',
  },
  logs: [],
  bottomTerminal: {
    open: false,
    title: ""
  },
  UITour:{
    config: null,
    currentTour: '',
    triggerNextStep: false,
    initStart: false,
    attributes: {
      continuous: true,
      disableScrolling: true,
      showProgress: true,
      showSkipButton: true
    }
  },
  aiAssistant: {
    aiAssistantOpen: false,
    isMinimized: false,
    loading: false, 
    autoProceed: "full",
    requestContext: {
      entityType: null,
      entity: null,
      isCreate: false
    }       
  },
  activeLabel: null,
  isBlueprintLoading: true,
  buildLoader: false,
  deployLoader: false,
  selectedNode: {},
  selectedTransactionId: "",
  eventToEdit: null,
  dataFlowRenderCount: 0,
  treeViewRenderCount: 0,
  renderCount: 0,
  leftDrawerStatus: false,
  imageMap: {
    id: undefined,
    open: false,
    url: '',
    asset: undefined,
    selectedTool: null,
    selectedAreaName: null,
    areas: []
  },
  rightDrawerStatus: false,
  bottomDrawerStatus: false,
  elementOnFocus: null,
  tabOnFocus: 0,
  isForcedFocus: false,
  elementToCopy: null,
  transactionState: {
    drawEvent: false,
    drawNestedTransaction: false,
    drawReuseTransaction: false,
    drawTemplateTransaction: false
  },
  highlightNode: null,
  transactionDrawnState: false,
  savingInProgress: false,
  disableRfPan: false,
  latestFieldAdded: [],
  currentTemplateTransaction: '',
  appMode: 'edit',
  currentViewId: null,
  assetsUpdated: false,
  secondarySnackBar: {
    open: false,
    autoHideDuration: 6000,
    severity: 'success',
    message: '',
    anchorOrigin: { vertical: "top", horizontal: "right" },
    save: false
  },
  multiLineSnackbar: {
    open: false,
    autoHideDuration: 6000,
    severity: 'success',
    message: '',
    anchorOrigin: { vertical: "top", horizontal: "right" },
    save: false
  },
  menuAction: null,
  viewElementToCopy: null,
  apiResponseCode: 0,
  reRender: 0,
  triggerBlueprintValidation: 0,
  psChangeDetector: 0,
  innerScreenRender: 0,
  apiResponseMessage: '',
  drawerHeader: '',
  nestedTransactionEvents: [],
  nestedTransactionClusterlets: [],
  nestedTransactionChildren: [],
  nestedTransactionInvoked: [],
  parentTransaction: '',
  isDisabled: false,
  codeEditStatus: false,
  isDocumentClicked: 0,  // Used to trigger the handler/utility function save alert when closing handler/utility function through any method,
  addSimulationTransaction: false,
  simulationRunning: false,
  closeBottomTerminal: false,
  toggleTransactionSelectorForSimulation: false,  //flag to decide whether to open the single transaction selector in simulation UI
  setPaperForTransactionInSimulation: false, //flag to enable simulation UI to draw a transaction rectangle
  setNodeExpanded: "",
  buildStatus: true,
  platformSchema: {},
  dialogScrollLocations: [],
  dashboardRefresh: {
    type: null,
    action: null,
    entity: null
  },
  uploads: [],
  llmComponents: {status:false, data:null, query_prompt:""},
  showAcceptRejectButton : false,
  buildVersion: {},
  llmQuery : "",
  llmModel : [],
  collapsableSidebarStatus : true,
};

export default function globalReducer(state = initialState, action) {
  // console.log("action------>", action)
  let logs = [];
  switch (action.type) {

    case types.TOGGLE_SNACKBAR:
      if (action.reset)
        return {
          ...state,
          snackbar: initialState.snackbar,
        };
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          ...action.payload,
        },
      };

    case types.TOGGLE_SEC_SNACKBAR:
      if (action.reset)
        return {
          ...state,
          secondarySnackBar: initialState.secondarySnackBar,
        };
      return {
        ...state,
        secondarySnackBar: {
          ...state.secondarySnackBar,
          ...action.payload,
        },
      };

    case types.TOGGLE_MULTI_LINE_SNACKBAR:
      if (action.reset)
        return {
          ...state,
          multiLineSnackbar: initialState.multiLineSnackbar,
        };
      return {
        ...state,
        multiLineSnackbar: {
          ...state.multiLineSnackbar,
          ...action.payload,
        },
      };

    case types.SET_BUILD_LOADER:
      return {
        ...state,
        buildLoader: action.payload.status
      };

    case types.SET_DEPLOY_LOADER:
      return {
        ...state,
        deployLoader: action.payload.status
      };

    case types.SELECTED_NODE:
      if (action.clear) {
        return {
          ...state,
          selectedNode: initialState.selectedNode,
        };
      }

      if (action.merge) {
        return {
          ...state,
          selectedNode: {
            ...state.selectedNode,
            data: { ...state.selectedNode.data, ...(action.payload || {}) },
          },
        };
      }

      return {
        ...state,
        selectedNode: {
          data: action.payload ? action.payload : state.selectedNode.data,
          anchorEl: action?.event?.srcElement || null,
        },
      };

    case types.SET_SELECTED_TRANSACTION_ID:
      return {
        ...state,
        selectedTransactionId: action.payload
      };

    case types.SET_SELECTED_EVENT:
      return {
        ...state,
        eventToEdit: action.payload
      }

    case types.SET_DF_RENDER:
      return {
        ...state,
        dataFlowRenderCount: action.payload
      }

    case types.SET_TV_RENDER:
      return {
        ...state,
        treeViewRenderCount: Math.floor(Math.random() * 999999)
      };

    case types.TRANSCTION_RENDER_COUNT:
      return {
        ...state,
        renderCount: state.renderCount + 1,
      };


    case types.UPDATE_BLUEPRINT_SLUG_DETAILS:
      return {
        ...state,
        details: {
          ...state.details,
          ...action.payload,
        }
      }

    case types.UPDATE_FULL_GLOBAL:
      return {
        ...state,
        ...action.payload
      }

    case types.HANDLE_LOGS:
      return {
        ...state,
        logs: action.clear ? [] : [...(state.logs || []), action.log]
      };

    case types.HANDLE_BOTTOM_TERMIAL:
      return {
        ...state,
        bottomTerminal: {
          ...state.logs,
          open: action.isOpen,
          title: action.title
        },
      };

    case types.HANDLE_TOP_RIGHT_INFO:
      return {
        ...state,
        topRightInfo: action.payload
      }
    
    case types.SET_ACTIVE_LABEL:
      return {
        ...state,
        activeLabel: action.payload
      }
    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    case 'OPEN_LEFT_DRAWER':
      return {
        ...state,
        leftDrawerStatus: true
      }

    case 'CLOSE_LEFT_DRAWER':
      return {
        ...state,
        leftDrawerStatus: false
      }

    case 'TOGGLE_LEFT_DRAWER':
      return {
        ...state,
        leftDrawerStatus: !state.leftDrawerStatus
      }

    case 'SET_IMAGE_MAP':
      return {
        ...state,
        imageMap: {
          ...state.imageMap,
          ...(action.payload || {})
        },
      };

    case 'RESET_IMAGE_MAP':
      return {
        ...state,
        imageMap: {
          id: undefined,
          open: false,
          url: '',
          asset: undefined,
          selectedTool: null,
          selectedAreaName: null,
          areas: []
        }
      }

      case 'SET_DASHBOARD_REFRESH':
        return {
          ...state,
          dashboardRefresh: {
            ...state.dashboardRefresh,
            ...(action.payload || {})
          },
        };


    case 'TOGGLE_RIGHT_DRAWER':
      let updateState = { ...state }

      if (state.rightDrawerStatus === true) {
        updateState.tabOnFocus = 0


      }


      return {
        ...updateState,
        rightDrawerStatus: !state.rightDrawerStatus
      }

    case 'TOGGLE_BOTTOM_DRAWER':
      return {
        ...state,
        bottomDrawerStatus: !state.bottomDrawerStatus
      }
      

    case 'SET_FOCUS_ELEMENT':
      return {
        ...state,
        elementOnFocus: action.payload
      }

    case 'SET_TAB_ON_FOCUS':

      return {
        ...state,
        tabOnFocus: action.payload
      }

    case 'SET_FORCED_FOCUS':

      return {
        ...state,
        isForcedFocus: action.payload
      }

    case 'SET_ELEMENT_TO_COPY':
      return {
        ...state,
        elementToCopy: action.payload
      }

    case 'SET_TESTCASE_TO_COPY':
      return {
        ...state,
        testcaseToCopy: action.payload
      }

    case 'DRAW_EVENT':
      return {
        ...state,
        transactionState: { drawEvent: action.status, drawNestedTransaction: false, drawReuseTransaction: false, drawTemplateTransaction: false }
      }

    case 'DRAW_NESTED_TRANSACTION':
      return {
        ...state,
        transactionState: { drawEvent: false, drawNestedTransaction: action.status, drawReuseTransaction: false, drawTemplateTransaction: false }
      }

    case 'DRAW_REUSE_TRANSACTION':
      return {
        ...state,
        transactionState: { drawEvent: false, drawNestedTransaction: false, drawReuseTransaction: action.status, drawTemplateTransaction: false }
      }

    case 'DRAW_TEMPLATE_TRANSACTION':
      return {
        ...state,
        transactionState: { drawEvent: false, drawNestedTransaction: false, drawReuseTransaction: false, drawTemplateTransaction: action.status }
      }

    case 'TRANSACTION_TO_CREATE':
      return {
        ...state,
        transactionToCreate: action.payload
      }

    case 'SET_TRANSACTION_STATE':
      return {
        ...state,
        transactionState: { drawEvent: action.status, drawNestedTransaction: action.status, drawReuseTransaction: action.status }
      }

    case types.SET_TERMINAL_OPEN:
      return {
        ...state,
        logs: {
          ...state.logs,
          open: action.payload,
          ...(action.payload || {}),
        },
      };

    case types.HIGHLIGHT_NODE:
      return {
        ...state,
        highlightNode: action.node
      }

    case types.DRAWN_TRANSACTION:
      return {
        ...state,
        transactionDrawnState: action.status
        //transactionState: { drawEvent: false, drawNestedTransaction: false, drawReuseTransaction: action.status }

      }

    case types.SAVING_IN_PROGRESS:
      return {
        ...state,
        savingInProgress: action.status
      }

    case types.SET_CLICKED_NODE:
      return {
        ...state,
        nodeClicked: action.payload
      }

    case types.SET_DISABLE_PAN:
      return {
        ...state,
        disableRfPan: action.status
      }

    //to add new field id and it's parent id to expand
    case types.SET_LATEST_FIELD_ADDED:
      return {
        ...state,
        latestFieldAdded: action?.payload
      }

    case types.SET_LOADING_FALSE:
      return {
        ...state,
        isBlueprintLoading: false
      }

    case types.SET_CURRENT_TEMPLATE_TRANSACTION:
      return {
        ...state,
        currentTemplateTransaction: action?.transactionName
      }

    case types.SET_APP_MODE:
      return {
        ...state,
        appMode: action.mode
      }

    case types.CURRENT_VIEW_ID:
      return {
        ...state,
        currentViewId: action.viewId
      }

    case 'ASSET_UPDATED':
      return {
        ...state,
        assetsUpdated: action.value
      }

    case 'SET_MENU_ACTION':
      return {
        ...state,
        menuAction: action.payload
      }

    case 'SET_VIEW_ELEMENT_TO_COPY':
      return {
        ...state,
        viewElementToCopy: action.payload
      }

    case types.SET_API_RESPONSE_CODE:
      return {
        ...state,
        apiResponseCode: action.responseCode
      }

    case types.SET_API_RESPONSE_MESSAGE:
      return {
        ...state,
        apiResponseMessage: action.responseMessage
      }

    case types.SET_RE_RENDER:
      return {
        ...state,
        reRender: Math.floor(Math.random() * 999999)
      };

    case types.SET_TRIGGER_VALIDATION:
      return {
        ...state,
        triggerBlueprintValidation: Math.floor(Math.random() * 999999)
      };
      
    case types.DETECT_PLATFORM_SCHEMA_CHANGE:
      return {
        ...state,
        psChangeDetector: Math.floor(Math.random() * 999999)
      };
  
    case types.SET_INNER_SCREEN_RENDER:
      return {
        ...state,
        innerScreenRender: Math.floor(Math.random() * 999999)
      };

    case types.SET_HEADER_NAME:
      return {
        ...state,
        drawerHeader: action.payload
      };

    case types.SET_TRANSACTION_EVENTS:
      return {
        ...state,
        nestedTransactionEvents: action.payload
      };

    case types.SET_TRANSACTION_CLUSTERLETS:
      return {
        ...state,
        nestedTransactionClusterlets: action.payload
      };

    case types.SET_TRANSACTION_CHILDREN:
      return {
        ...state,
        nestedTransactionChildren: action.payload
      };

    case types.SET_TRANSACTION_INVOKED:
      return {
        ...state,
        nestedTransactionInvoked: action.payload
      };

    case types.SET_PARENT_TRANSACTION:
      return {
        ...state,
        parentTransaction: action.payload
      };

    case types.SET_DISABLED:
      return {
        ...state,
        isDisabled: action.payload
      };

    case types.SET_CODE_EDIT_STATUS:
      return {
        ...state,
        codeEditStatus: action.payload
      };

    case types.SET_IS_DOCUMENT_CLICKED:
      return {
        ...state,
        isDocumentClicked: Math.floor(Math.random() * 999999)
      };

    case types.SET_SIMULATION_TRANSACTION:
      return {
        ...state,
        addSimulationTransaction: action.payload
      };


    case types.SET_BOTTOM_TERMINAL_CLOSED:
      return {
        ...state,
        closeBottomTerminal: action.payload
      };

    case types.OPEN_TRANSACTION_SELECTOR:
      return {
        ...state,
        toggleTransactionSelectorForSimulation: action?.payload
      };

    case types.SET_PAPER_FOR_SIMULATION_TRANSACTION:
      alert(action.payload)
      return {
        ...state,
        setPaperForTransactionInSimulation: action?.payload
      }

    case types.SET_NODE_EXPANDED:
      return {
        ...state,
        setNodeExpanded: action?.payload
      }

    case types.SET_BUILD_STATUS:
      return {
        ...state,
        buildStatus: action?.payload
      }

    case types.TRIGGER_TOUR:
        return {
          ...state,
          UITour: {
            ...state.UITour,
            currentTour: action?.payload?.currentTour,
            initStart: action?.payload?.initStart || false,
            runningStatus: action?.payload?.runningStatus || !state?.UITour?.runningStatus,
            attributes: {
              ...(state.UITour.attributes),
              ...(action?.payload?.attributes || {}),
            }
          }
        }

    case types.ADD_TOUR_CONFIG:
      return {
        ...state,
        UITour: {
          ...state.UITour,
          config: action.payload
        }
      }

    case types.TOGGLE_NEXT_STEP:
      return {
        ...state,
        UITour: {
          ...state.UITour,
          triggerNextStep: action?.payload || !state?.UITour.triggerNextStep
        }
      }
    case types.OPEN_RIGHT_DRAWER:
        return {
          ...state,
          rightDrawerStatus: true
        }
    case types.INIT_MIGRATION_APPROVAL:
      return {
        ...state,
        platformSchema: {
          errorCount: action?.payload?.errorCount || null,
          isApprovalStage: action?.payload?.approvalStage || false,
          schemaVersionToMigrate: action?.payload?.schemaVersion || null, 
          isManual: action?.payload?.isManual || false,
          incompatibilities: action?.payload?.incompatibilities || [],
        }
      }
    case types.SAVE_DIALOG_SCROLL_LOCATION:
      let locations = state.dialogScrollLocations
      let itemIndex = locations?.findIndex(item => item.title === action.payload.title);

      if(itemIndex !== -1){ 
        locations[itemIndex] = action.payload
      }else{
        locations.push(action.payload)
      }
      
      return {
        ...state,
        dialogScrollLocations: locations
      }

    
    case 'SET_BUILD_VERSION': 
      return {
        ...state,
        buildVersion: {
          ...(action.payload || {})
        },
      };

    case types.START_UPLOAD_PROGRESS:
        let newFile = {
          id: action.payload.id,
          fileName: action.payload.fileName,
          progress: 0,
          status: 'uploading',
          estimatedTimeLeft: null,
          blueprint_id: action.payload.blueprint_id
        }
        return {
          ...state,
          uploads: [
            ...state.uploads,
            newFile
          ]
        }
    case types.UPDATE_UPLOAD_PROGRESS: {
      const { progress, id, estimatedTimeLeft, status, fileName, blueprint_id } = action.payload;
      const existingUploadIndex = state.uploads.findIndex(u => u.id === id);

      if (existingUploadIndex !== -1) {
        return {
          ...state,
          uploads: state.uploads.map(upload =>
            upload.id === id
              ? { ...upload, progress, estimatedTimeLeft, status, fileName, blueprint_id }
              : upload
          )
        };
      } else {
        return {
          ...state,
          uploads: [
            ...state.uploads,
            {
              id,
              progress,
              estimatedTimeLeft,
              status,
              fileName,
              blueprint_id
            }
          ]
        };
      }
    }

    case types.REMOVE_UPLOAD_PROGRESS:
      return {
        ...state,
        uploads: state.uploads.filter(item => item.id !== action.payload.id)
      }

    case types.GENERATE_LLM_COMPONENTS:
      return {
        ...state,
        llmComponents: action?.payload
      }

    case types.SHOW_ACCEPT_REJECT_BUTTONS:
      return {
        ...state,
        showAcceptRejectButton: action?.payload
      }
    
    case types.LLM_QUERY:
      return {
        ...state,
        llmQuery : action?.payload
      }

    case types.LLM_MODEL:
      return {
        ...state,
        llmModel: action?.payload
      }

    case types.AI_ASSISTANT_UPDATE:
        
        return {
          ...state,
          aiAssistant: {
            ...state.aiAssistant,
            ...(action.payload || {})
          }
        }
    case types.AI_ASSISTANT_MODAL_OPEN:
        
        return {
          ...state,
          aiAssistant: {
            ...state.aiAssistant,
            aiAssistantOpen: true
          }
        }

    case types.AI_ASSISTANT_MODAL_CLOSE:
        
        return {
          ...state,
          aiAssistant: {
            ...state.aiAssistant,
            aiAssistantOpen: false
          }
        }

    case types.COLLAPSABLE_SIDEBAR_STATUS:
      return {
        ...state,
        collapsableSidebarStatus: action?.payload
      }
    
    case types.SET_AI_REQUEST_ENTITY:
      return {
        ...state,
        aiAssistant: {
          ...state.aiAssistant,
          requestContext: {
            ...state.aiAssistant.requestContext,
            entity: action.payload
          }
        }
      };
    case types.SET_AI_AUTO_PROCEED:
      return {
        ...state,
        aiAssistant: {
          ...state.aiAssistant,
          autoProceed: action.payload
        }
      };
    case types.GENERATE_WIDGET_TRANSACTION:
        
        return {
          ...state,
          aiWidgetTransaction: action.payload
        }

    case types.SET_LOG_HELPER:

        return {
          ...state,
          logHelpers: action.payload
        }

    case types.TOGGLE_SIMULATION_RUN:

        return {
          ...state,
          simulationRunning: action.payload || false
        }
    
    case types.TOGGLE_VALIDATOR:

        return {
          ...state,
          openValidator: action.payload || false
        }
    
    case types.TOGGLE_DEPLOYMENT:

        return {
          ...state,
          openDeployment: action.payload || false
        }
    
    case types.UPDATE_LOG_REDIRECTION_DATA:
        return {
          ...state,
          logRedirectionData: action.payload || null
        }
    default:
      return state;
  }
}

